import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { WithLightTheme } from '@statsbomb/kitbag-themes';
import { StyledSubMenu } from './SideNavigationSubMenu.styles.js';
import { useSideNavigationThemeContext } from '../SideNavigationContexts/SideNavigationThemeContext.js';

var SideNavigationSubMenu = forwardRef(function (_ref, ref) {
  var topOffset = _ref.topOffset,
    isSelected = _ref.isSelected,
    isSubmenuOpen = _ref.isSubmenuOpen,
    children = _ref.children;
  var _useSideNavigationThe = useSideNavigationThemeContext(),
    isOpen = _useSideNavigationThe.isOpen,
    isDarkMode = _useSideNavigationThe.isDarkMode,
    isTouch = _useSideNavigationThe.isTouch;
  var renderOriginalTheme = !isDarkMode && isOpen;
  var Component = renderOriginalTheme ? WithLightTheme : React__default.Fragment;
  return React__default.createElement(Component, null, React__default.createElement(StyledSubMenu, {
    ref: ref,
    $topOffset: topOffset,
    $isOpen: isOpen,
    $isTouch: isTouch,
    $isSelected: isSelected,
    $isSubmenuOpen: isSubmenuOpen,
    "aria-hidden": !isSubmenuOpen
  }, children));
});
SideNavigationSubMenu.propTypes = {
  children: PropTypes.node.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isSubmenuOpen: PropTypes.bool.isRequired,
  topOffset: PropTypes.number.isRequired
};

export { SideNavigationSubMenu, SideNavigationSubMenu as default };
//# sourceMappingURL=SideNavigationSubMenu.js.map
